import { render, staticRenderFns } from "./AvatarTip.vue?vue&type=template&id=6391b9d1&"
import script from "./AvatarTip.vue?vue&type=script&lang=js&"
export * from "./AvatarTip.vue?vue&type=script&lang=js&"
import style0 from "./AvatarTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports